<app-header [displaySearchField]='false'></app-header>
<main class='main-wrapper'>
  <div class='container'>
    <img src='assets/not-found-image.svg' alt='not-found-page-image' width='582' height='310' />
    <h2>The page you are looking for doesn’t exist.</h2>
    <button (click)='back()' class='primary-btn'>Go Back</button>
  </div>
</main>
